import { Blurhash } from "react-blurhash";
import { useRef, useEffect } from "react";
import { useImmer } from "use-immer";

export const Image = ({ src, blurhash, width, height, ...props }) => {
  const [imageLoaded, updateImageLoaded] = useImmer({ loaded: false });
  const imgRef = useRef(null);

  useEffect(() => {
    if (imgRef.current && imgRef.current.complete && imgRef.current.naturalWidth > 0) {
      updateImageLoaded({ loaded: "already_loaded" });
    } else {
      updateImageLoaded({ loaded: false });
    }
  }, [src, updateImageLoaded]);

  const containerStyle = {
    display: "contents",
  };

  const placeholderStyle = {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    margin: "auto",
    width: "auto",
    height: "auto",
    maxWidth: "100%",
    maxHeight: "100%",
    aspectRatio: width / height,
    transition: imageLoaded.loaded === "already_loaded" ? "none" : "opacity 0.3s ease",
    opacity: imageLoaded.loaded ? 0 : 1,
    pointerEvents: "none"
  }

  return (
    <div style={containerStyle}>
      {blurhash && (
        <div style={placeholderStyle}>
          <Blurhash
            hash={blurhash}
            width="100%"
            height="100%"
            resolutionX={32}
            resolutionY={32}
          />
        </div>
      )}
      <img
        ref={imgRef}
        src={src}
        {...props}
        onLoad={(e) => {
          updateImageLoaded((draft) => {
            if (!draft.loaded) {
              draft.loaded = true;
            }
          })
          props.onLoad?.(e);
        }}
        width={width}
        height={height}
      />
    </div>
  );
};

export const FileImage = ({ file, ...props }) => {
  return <Image src={"https://cdn.sapientclinician.com/files/"+file._id+"/"+file.sizes[0].src+"?"+file.signing} width={file.sizes[0].width} height={file.sizes[0].height} blurhash={file.blurhash} {...props} />;
};

